import { v1_3_identity_claim_options_scope } from "./v1_3_identity_claim_options_scope";

export class v1_3_identity_claim_options {
  public scopes: v1_3_identity_claim_options_scope[];
}
